
import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import serialize from 'form-serialize';
import axios from 'axios';

import {api_path} from '../../server.js'; 
import logo from '../../logo.png'

function CadastrarSenha() {

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password1, setPassword1] = useState('');
  const [alterado, setAlterado] = useState('NAO');
/*
  const [email_codigo, setEmail_codigo] = useState('');

  const [codigorecebido, setCodigorecebido] = useState('');
  const [s1, setS1] = useState('');
  const [s2, setS2] = useState('');
  const [codsended, setCodSended] = useState('NAO');
  
  const [txt_codigoenviado, setTxt_codigoenviado] = useState('');
  const [txt_codigoenviadomsg, setTxt_codigoenviadomsg] = useState('');
  const [txt_codigoenviadoerro, setTxt_codigoenviadoerro] = useState('');
  const [txt_codigoenviadoemailcliente, setTxt_codigoenviadoemailcliente] = useState('');
*/

//http://localhost/fertnutri.api/sistema/cliente.login.php?acao=cadastrarSenha&email=deitosjr@gmail.comXx&s1=1&s2=1
  function cadastrarSenha(e){
    const form = e.currentTarget;
    let dados=serialize(form, {hash: true, empty: true})
    const bodyDadosProp = { acao: 'cadastrarSenha', dados}
        axios.post(api_path()+'sistema/cliente.login.php', bodyDadosProp, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then((response) => {
            
          let acao = response.data.acao;
          let erro = response.data.erro;
          let msg = response.data.msg;
          /*setEmail setPassword setPassword1*/
          if(msg!="")
            {
              alert(msg);
            }

            if(erro==="N"){
              if(acao=="login"){
                //alert('ir para login');
                document.location.href = '../';
              }
            }
            if(erro==="S"){
              if(acao=="esquecisenha"){
                //alert('ir para login');
                //zerar senhas

                setPassword('');
                setPassword1('');
                document.location.href = '../';
              }
              if(acao=="digiteemailnovamente"){
                //alert('ir para login');
                //zerar senhas e eamil
                setEmail('');
                setPassword('');
                setPassword1('');
              }
              if(acao=="tenteemailnovamente"){
                //alert('ir para login');
                //zerar senhas e eamil
                setEmail('');
                setPassword('');
                setPassword1('');
              }


            }

              //setAlterado('SIM');

              ///login
            
            
          })
          .catch(function(response) {
                //handle error
                //console.log(response);
          });
  }



  function handleSubmitSenha(e){
    e.preventDefault();
    cadastrarSenha(e);
  }
  return (
    <div class="grid-container form-signin">

        <div className="grid-x grid-padding-x account-wall">
          <div className="large-12 small-12 medium-12 cell"><img className="profile-img" src={logo} alt=""/></div>
          <div className="large-12 small-12 medium-12 cell text-center">Cadastrar senha</div>
          <div className="large-12 small-12 medium-12 cell">
            <form onSubmit={handleSubmitSenha}>
              <input type="email" name="email" placeholder="Digite seu email" value={email} onChange={ (e) => setEmail(e.target.value) } required autofocus/>
              <input type="password" name="s1" placeholder="Digite sua senha" value={password} onChange={ (e) => setPassword(e.target.value) } required/>
              <input type="password" name="s2" placeholder="Confirme sua senha" value={password1} onChange={ (e) => setPassword1(e.target.value) } required/>
              <button className="button expanded" type="submit">Acessar</button>
            </form>
          </div>
          <div className="large-12 small-12 medium-12 cell">
            <Link to="/login/recuperar-senha" className="new-account">Esqueceu sua senha?</Link>
          </div>
          <div className="large-12 small-12 medium-12 cell">
            <Link to="/comprar" className="new-account">Criar uma conta</Link>
          </div>
        </div>

    </div>

  );
}

export default CadastrarSenha;
